import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";

export const Vehicle = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const res = await axios.post("https://cabbooking.kidsconnect.tech/addVehicle/getVehicleId", {
          vendorID: location.state,
        });
        if (res.data.success === 1) {
          setData(res.data.result);
        } else {
          toast.error(res.data.message || "No vehicles found");
        }
      } catch (error) {
        console.error("Axios error:", error);
        toast.error("Request failed: " + error.message);
      } finally {
        setLoader(false);
      }
    };

    fetchVehicles();
  }, [location.state]);

  const navigateToVehicleInfo = (vehicle) => {
    if (path === "/admin/vehicle") {
      navigate("/admin/vehicle_info", { state: vehicle });
    }
  };

  return (
    <>
      {loader && <Loader />}
      <div className="bg-white">
        {data.length > 0 ? (
          <>
            <div className="p-4 underline underline-offset-4">
              Total Cars: {data.length}
            </div>
            <div className="flex flex-wrap">
              {data.reverse().map((e, i) => (
                <div
                  key={i}
                  onClick={() => navigateToVehicleInfo(e)}
                  className="w-1/2 grid p-4 place-items-center"
                >
                  <div className="w-full max-w-sm p-4 border rounded-md hover:border-slate-400 cursor-pointer">
                    <img
                      src={e.vehicleImg}
                      alt="Vehicle"
                      className="rounded-2xl w-full h-56 object-contain object-center p-2"
                    />

                    <div className="flex justify-between mt-2">
                      <h3 className="text-lg font-semibold">Vehicle Name</h3>
                      <p>{e.vehicleBrand} - {e.vehicleModel}</p>
                    </div>
                    <div className="flex justify-between">
                      <h3 className="text-lg font-semibold">Vehicle Number</h3>
                      <p>{e.vehicleNumber}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="p-6 text-center text-xl font-semibold">
            No Vehicle Available
          </div>
        )}
      </div>
    </>
  );
};
